module.exports = __webpack_public_path__ + "img/HotspotTeleport.84bfdb3e.png";